import React, { useState, useEffect } from 'react';

export function ContactDealerInlineFormLoader({ load, ...props }) {
    const [LazyForm, setLazyForm] = useState(null);
    useEffect(() => {
        if (load && !LazyForm) {
            setLazyForm(
                React.lazy(() =>
                    import(
                        /* webpackChunkName: "ContactDealerInlineForm" */ './ContactDealerInlineForm'
                    )
                )
            );
        }
    }, [load, LazyForm]);
    return (
        LazyForm && (
            <React.Suspense fallback={''}>
                <LazyForm {...props} />
            </React.Suspense>
        )
    );
}
